import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {Transient} from '../core/entity/core.entity.transient';
import {EnvironmentKind} from '../enum/environment.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {PaperKind} from '../enum/report.paper.kind';
import {RouteEntity} from './route.entity';
import {SystemEntity} from './system.entity';

@EntityTable('report', '7d9c74d4-2fbc-4b73-a9c6-729ce84e7187')
export class ReportEntity extends Entity {

    @Column(FieldTypeKind.STRING)
    public name: string;

    @Column(FieldTypeKind.ANY)
    public paperSize: any;

    @Column(FieldTypeKind.LONG)
    public paperKind: PaperKind;

    @Column(FieldTypeKind.ANY)
    public margin: any;

    @JoinColumn(FieldTypeKind.GUID, RouteEntity, false, false, FieldRelationKind.BELONGS_TO, 'route', 'aliasId', 'routeReportId')
    public routeReportId: string;

    @JoinColumn(FieldTypeKind.GUID, SystemEntity, false, false, FieldRelationKind.BELONGS_TO, 'system')
    public systemId: string;

    @Transient()
    public route: RouteEntity;

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;

}
